/*
  Keeps the handling-charge line in sync with the cart:
  quantity of handling line === total quantity of products tagged "shipping-charge-test".
  Eligible quantity comes from sections/handling-sync.liquid (tags are not available in /cart.js).
*/
(function () {
  const HANDLING_VARIANT_ID = 68322042314987;
  const RELOAD_GUARD_KEY = 'handlingSyncReloadedAt';
  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)/;
  const originalFetch = window.fetch.bind(window);
  let syncing = false;
  let pending = false;
  let rerun = false;
  let inflight = 0;

  // Checkout buttons are blocked (CSS + capture handlers, so re-rendered buttons stay covered)
  // while any cart request is in flight or the handling line is being synced.
  const style = document.createElement('style');
  style.textContent =
    'html.cart-busy [name="checkout"], html.cart-busy #CartDrawer-Checkout, html.cart-busy #checkout' +
    '{pointer-events:none;opacity:.5;cursor:not-allowed}';
  document.head.appendChild(style);

  function updateBusy() {
    document.documentElement.classList.toggle('cart-busy', inflight > 0 || syncing || pending);
  }

  function blockIfBusy(event) {
    if (!document.documentElement.classList.contains('cart-busy')) return;
    const target = event.target.closest && event.target.closest('[name="checkout"], #CartDrawer-Checkout, #checkout');
    const isCartForm = event.type === 'submit' && event.target.matches('#cart, #CartDrawer-Form');
    if (target || isCartForm) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  document.addEventListener('click', blockIfBusy, true);
  document.addEventListener('submit', blockIfBusy, true);

  // Track theme-initiated cart mutations so checkout is blocked until they and the sync finish.
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!CART_MUTATION_RE.test(url)) return originalFetch(input, init);
    inflight++;
    updateBusy();
    return originalFetch(input, init).finally(() => {
      inflight--;
      pending = true;
      updateBusy();
      setTimeout(syncHandling, 300);
    });
  };

  async function getState() {
    const res = await originalFetch(`${window.routes.cart_url}?section_id=handling-sync&t=${Date.now()}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return JSON.parse(doc.body.textContent.trim());
  }

  async function post(url, body) {
    const res = await originalFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return res.ok;
  }

  async function refreshUI() {
    const res = await originalFetch(`/?sections=cart-drawer,cart-icon-bubble&t=${Date.now()}`);
    const sections = await res.json();
    const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

    const drawerInner = document.querySelector('cart-drawer .drawer__inner');
    const newInner = parse(sections['cart-drawer'], '.drawer__inner');
    if (drawerInner && newInner) drawerInner.innerHTML = newInner.innerHTML;
    const drawer = document.querySelector('cart-drawer');
    const newDrawer = parse(sections['cart-drawer'], 'cart-drawer');
    if (drawer && newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));

    const bubble = document.getElementById('cart-icon-bubble');
    const newBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && newBubble) (bubble.querySelector('.shopify-section') || bubble).innerHTML = newBubble.innerHTML;
  }

  async function syncHandling() {
    if (syncing) {
      rerun = true;
      return;
    }
    syncing = true;
    updateBusy();
    try {
      const { eligible, handlingQty, handlingKey } = await getState();
      if (eligible === handlingQty) return;

      // Only now (eligible items changed the handling quantity) show the "calculating" state on the handling line
      document.documentElement.classList.add('handling-updating');
      let ok;
      if (handlingQty === 0) {
        ok = await post(window.routes.cart_add_url + '.js', { items: [{ id: HANDLING_VARIANT_ID, quantity: eligible }] });
      } else {
        ok = await post(window.routes.cart_change_url + '.js', { id: handlingKey, quantity: eligible });
      }
      if (!ok) return;

      if (window.location.pathname === window.routes.cart_url) {
        const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
        if (Date.now() - last > 5000) {
          sessionStorage.setItem(RELOAD_GUARD_KEY, Date.now());
          window.location.reload();
        }
      } else {
        await refreshUI();
      }
    } catch (e) {
      console.error('handling-sync failed', e);
    } finally {
      document.documentElement.classList.remove('handling-updating');
      syncing = false;
      pending = rerun;
      updateBusy();
      if (rerun) {
        rerun = false;
        setTimeout(syncHandling, 0);
      }
    }
  }

  pending = true;
  updateBusy();
  document.addEventListener('DOMContentLoaded', syncHandling);
})();
